import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

// Placeholder is added whenever an image is added, while we do some
// background processing to reduce size, etc
export const placeholderPlugin = new Plugin({
  state: {
    init() {
      return DecorationSet.empty;
    },
    apply(tr, set) {
      // Adjust decoration positions to changes made by the transaction
      let updatedSet = set.map(tr.mapping, tr.doc);
      // See if the transaction adds or removes any placeholders
      const action = tr.getMeta(placeholderPlugin);
      if (action && action.add) {
        const widget = document.createElement('placeholder');
        const deco = Decoration.widget(action.add.pos, widget, {
          id: action.add.id,
        });
        updatedSet = set.add(tr.doc, [deco]);
      } else if (action && action.remove) {
        updatedSet = set.remove(
          set.find(null, null, spec => spec.id === action.remove.id),
        );
      }
      return updatedSet;
    },
  },
  props: {
    decorations(state) {
      return placeholderPlugin.getState(state);
    },
  },
});

export const findPlaceholder = (state, id) => {
  const decos = placeholderPlugin.getState(state);
  const found = decos.find(null, null, spec => spec.id === id);
  return found.length ? found[0].from : null;
};
